import * as marketingActions from '../actions/marketingPage';

const defaultState = {
    modules: [],
    searchResults: [],
    marketingList: [],
    selectedModule: null
};

export default function(state = defaultState, action) {

    switch (action.type) {

        case marketingActions.MARKETING_MODULE_SELECTED:

            return {
                ...state,
                selectedModule: action.module
            };

        case marketingActions.MARKETING_MODULES_REFRESHED:

            return {
                ...state,
                modules: action.modules
            };

        case marketingActions.UPDATE_MARKETING_SEARCH_RESULTS:

            return {
                ...state,
                searchResults: action.searchResults
            }

        case marketingActions.UPDATE_MARKETING_LIST_ITEMS:

            return {
                ...state,
                marketingList: action.data
            }

        case marketingActions.ADD_MARKETING_ITEM_TO_LIST:

            return {
                ...state,
                marketingList: [
                    ...state.marketingList,
                    action.response[0]
                ]
            }

        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./reducers/marketingPage.js